import { onAttach, onSize } from '../ui/attach';
import { UIColor } from '../ui/color';
import { UITooltip } from '../ui/component/tooltip';
import { $el } from '../ui/elements';
import { UISVG } from '../ui/svg';
import { UIClassesSpec, UISize, UIPoint } from '../ui/types';
import { UIView } from '../ui/view';
import { $log } from '../y/debug';
import { CHLegendItem } from './legend';

export interface CHChartOptions {
    tint?: UIColor;
    tooltip?: boolean;
    classes?: UIClassesSpec;
    autoresize?: boolean;
}

export interface CHChartElement {
    layout(size: UISize): void;
    render(svg: UISVG, overlay: HTMLElement): void | UISize;
    onMouse(point: UIPoint | undefined, tooltip: UITooltip): void;
    fillLegend?(items: CHLegendItem[]): void;
}

export class CHChart extends UIView {
    private _svg: UISVG;
    private _overlay: HTMLElement;

    private _size?: UISize;
    private _options: CHChartOptions;

    private _elements: CHChartElement[];

    constructor(options: CHChartOptions = {}) {
        super('div', ['ch-chart', options.classes]);

        this._options = options;
        this._elements = [];

        this.ui_add([
            this._svg = new UISVG,
            this._overlay = $el.DIV('r-overlay')
        ]);

        if(options.tooltip !== false) {
            const tooltip = new UITooltip([], { kind: 'k-chart', inside: this });

            this._overlay.addEventListener('mousemove', (ev) => {
                const point: UIPoint = [ev.offsetX, ev.offsetY];
                for(const e of this._elements) {
                    e.onMouse(point, tooltip);
                }
            });

            this._overlay.addEventListener('mouseleave', (_ev) => {
                for(const e of this._elements) {
                    e.onMouse(undefined, tooltip);
                }
            });
        }

        if(options.autoresize) {
            onAttach(this, () => {
                this._size = [this.root.offsetWidth, this.root.offsetHeight];
                $log('app', 'onAttach chart', this._size);
                this._layoutAll();
                this._renderAll();
            });
        } else {
            onSize(this, (content) => {
                this._size = content;
                this._layoutAll();
                this._renderAll();
            });
        }

    }

    private _layoutAll() {
        const size = this._size!;
        for(const e of this._elements) {
            e.layout(size);
        }
    }

    private _renderAll() {
        for(const e of this._elements) {
            const size = e.render(this._svg, this._overlay);
            if(size && this._options.autoresize) {
                this.root.style.width = size[0] + 'px'; // TODO: ??????????
                this.root.style.height = size[1] + 'px';
            }
        }
    }

    setElements(elements: CHChartElement[]) {
        this._svg.root.innerHTML = '';
        this._overlay.innerHTML = '';
        this._elements = elements;

        if(this.isConnected) {
            this._layoutAll();
            this._renderAll();
        }
    }

    addElement(element: CHChartElement) {
        this._elements.push(element);

        if(this.isConnected) {
            element.layout(this._size!);
            element.render(this._svg, this._overlay);
        }
    }

    get legend_items() {
        const items: CHLegendItem[] = [];

        for(const e of this._elements) {
            e.fillLegend && e.fillLegend(items);
        }

        return items;
    }
}
